module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_07B.7df19d41.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_07B.mp3
// module id = 109
// module chunks = 0